import React, { useState, useEffect } from 'react';
import SalikGenerator from './components/SalikGenerator';
import ParkingGenerator from './components/ParkingGenerator';
import TrafficGenerator from './components/TrafficGenerator';
import CorporateGenerator from './components/CorporateGenerator';
import CompanyManager from './components/CompanyManager';
import Layout from '../../components/Layout';
import Card from '../../ui/Card/Card';
import Tabs from '../../ui/Tabs/Tabs';
import Icon from '../../ui/Icon';
import { ICONS } from '../../ui/icon-map';
import { usePermissions } from '../../hooks/usePermissions';
import { PERMISSIONS } from '../../constants/permissions';

const InvoiceGenerator = () => {

    const [activeTab, setActiveTab] = useState('salik');
    const { hasPermission } = usePermissions();

    useEffect(() => {
        document.title = "Invoice Generator | YELO Unified";
    }, []);

    const tabs = [
        { id: 'corporate', label: 'Corporate', glyph: ICONS.document, permission: PERMISSIONS.view_invoices },
        { id: 'salik', label: 'Salik', glyph: ICONS.salik, permission: PERMISSIONS.view_invoice_salik },
        { id: 'parking', label: 'Parking', glyph: ICONS.car, permission: PERMISSIONS.view_invoice_parking },
        { id: 'fines', label: 'Traffic Fines', glyph: ICONS.fines, permission: PERMISSIONS.view_invoice_traffic },
        { id: 'companies', label: 'Companies', glyph: ICONS.users, permission: PERMISSIONS.view_invoices },
    ];

    const tabItems = tabs
        .filter(tab => hasPermission(tab.permission))
        .map(tab => ({ id: tab.id, label: tab.label, icon: <Icon glyph={tab.glyph} size="sm" /> }));

    return (
        <Layout title="Invoice Generator" subtitle="Salik, Parking & Fines">
            <div className="mx-auto w-full max-w-6xl space-y-4">
                <Tabs
                    items={tabItems}
                    value={activeTab}
                    onChange={setActiveTab}
                    label="Invoice type"
                    idPrefix="invoice-tab"
                />

                <Card>
                    <div role="tabpanel" id={`invoice-tab-panel-${activeTab}`} aria-labelledby={`invoice-tab-${activeTab}`}>
                        {activeTab === 'corporate' && <CorporateGenerator />}
                        {activeTab === 'salik' && <SalikGenerator />}
                        {activeTab === 'parking' && <ParkingGenerator />}
                        {activeTab === 'fines' && <TrafficGenerator />}
                        {activeTab === 'companies' && <CompanyManager />}
                    </div>
                </Card>
            </div>
        </Layout>
    );
};

export default InvoiceGenerator;
